export default "__VITE_ASSET__DAWxT9oi__"